import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const SubscriptionDone = ({ project, onBack, currentStatus }) => {
  return (
    <>
      <Navbar
        project={project}
        progress={currentStatus?.progress}
        showHelp={false}
        step={5}
        stepCount={5}
        title="Bienvenu à Mobilité Mutuelle"
      />
      <View onBack={onBack} />
    </>
  );
};

export default SubscriptionDone;
